import type { DrawerContentProps } from '@chakra-ui/react';
import { Drawer, useDrawerContext } from '@chakra-ui/react';
import { useCallback } from 'react';

import { useIsDesktop } from '../MobileOrDesktop';
import { DragBar } from './DragBar';
import { useDragController } from './useDragController';

export const DragDrawerContent = ({
  children,
  ...props
}: DrawerContentProps & {
  'data-disabled'?: boolean;
}) => {
  const { setOpen } = useDrawerContext();
  const disable = props['data-disabled'];
  const isDesktop = useIsDesktop();

  const { ref, isTouching, triggerRef } = useDragController({
    onDrag: useCallback(
      (ele: HTMLDivElement, offsetY: number) =>
        (ele.style.bottom = `-${Math.max(offsetY, 0)}px`),
      [],
    ),
    onClose: () => {
      setOpen(false);
    },
    onReset: useCallback((ele: HTMLDivElement) => (ele.style.bottom = '0'), []),
    disabled: disable,
  });

  if (isDesktop) {
    return (
      <Drawer.Content position="relative" {...props}>
        {children}
      </Drawer.Content>
    );
  }

  return (
    <Drawer.Content
      ref={ref}
      position="relative"
      {...props}
      className={`${props.className ?? ''} drag-drawer-content`}
    >
      <DragBar
        ref={triggerRef}
        hidden={disable}
        position="absolute"
        top="0"
        left="50%"
        transform="translateX(-50%)"
        pt="12px"
        buttonContainerProps={{
          alignItems: 'flex-start',
        }}
        isTouching={isTouching}
        onToggle={() => {
          setOpen(false);
        }}
      />
      {children}
    </Drawer.Content>
  );
};
